import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import CategoryGrid from './components/CategoryGrid';
import MangaSection from './components/MangaSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroBanner />

        <CategoryGrid />

        <MangaSection
          title="热门推荐"
          subtitle="全网最受欢迎的韩漫作品，口碑爆棚"
          mangaIds={[2, 6, 12, 21, 4, 3]}
          viewAllLink="/category/rexia-recommend"
          badge="HOT"
        />

        <section className="bg-background-100 py-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                阅读数据
              </h2>
              <p className="mt-3 text-foreground-600 text-sm md:text-base">
                韩漫大全致力于为全球韩漫爱好者提供最佳的阅读体验
              </p>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                <div className="text-3xl font-heading font-bold text-primary-500">24,000+</div>
                <div className="text-sm text-foreground-600 mt-2">漫画资源</div>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                <div className="text-3xl font-heading font-bold text-accent-500">5,800万+</div>
                <div className="text-sm text-foreground-600 mt-2">总阅读量</div>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                <div className="text-3xl font-heading font-bold text-primary-500">320万+</div>
                <div className="text-sm text-foreground-600 mt-2">月活用户</div>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                <div className="text-3xl font-heading font-bold text-accent-500">99.7%</div>
                <div className="text-sm text-foreground-600 mt-2">用户满意度</div>
              </div>
            </div>
          </div>
        </section>

        <MangaSection
          title="最新更新"
          subtitle="热门连载漫画，每日同步更新"
          mangaIds={[3, 6, 8, 9, 12, 18]}
          viewAllLink="/category/rexia-recommend"
          viewAllLabel="更多更新"
          badge="NEW"
        />

        <MangaSection
          title="恋爱漫画精选"
          subtitle="最甜蜜的韩国恋爱漫画合集"
          mangaIds={[1, 5, 10, 15, 18, 3]}
          viewAllLink="/category/lianai-romance"
        />

        <MangaSection
          title="奇幻冒险必看"
          subtitle="异世界冒险与奇幻传说"
          mangaIds={[2, 6, 8, 12, 20, 21]}
          viewAllLink="/category/qihuan-fantasy"
        />

        <FAQSection />
      </main>

      <Footer />
    </>
  );
}